const setRouteMessage = (state) => (route) => (message) => {
  const newState = {
    ...state,
    routeMessages: [
      ...state.routeMessages.filter(({ route: r }) => r !== route),
      { route, message },
    ],
  };

  return newState;
};

export default setRouteMessage;
